// ImpactStats organism component
import { useState, useEffect } from "react";
import { StatCard } from "../molecules";
import { statsService } from "../../services/statsService";

export const ImpactStats = () => {
  const [widowsHelped, setWidowsHelped] = useState(0);
  const [homesRepaired, setHomesRepaired] = useState(0);
  const [carsServiced, setCarsServiced] = useState(0);
  const [targets, setTargets] = useState({
    widowsSupported: 0,
    homesRepaired: 0,
    carsServiced: 0,
  });
  const [loading, setLoading] = useState(true);

  // Fetch stats from backend
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const stats = await statsService.getStats();
        setTargets(stats);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching stats:", error);
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  // Animate counters to target values
  useEffect(() => {
    if (loading || targets.widowsSupported === 0) return;

    const animationInterval = 40; // milliseconds
    const duration = 2000; // 2 seconds total animation time
    const steps = duration / animationInterval;

    const widowsIncrement = Math.ceil(targets.widowsSupported / steps);
    const homesIncrement = Math.ceil(targets.homesRepaired / steps);
    const carsIncrement = Math.ceil(targets.carsServiced / steps);

    const interval = setInterval(() => {
      setWidowsHelped((prev) => {
        if (prev >= targets.widowsSupported) return targets.widowsSupported;
        return Math.min(prev + widowsIncrement, targets.widowsSupported);
      });
      setHomesRepaired((prev) => {
        if (prev >= targets.homesRepaired) return targets.homesRepaired;
        return Math.min(prev + homesIncrement, targets.homesRepaired);
      });
      setCarsServiced((prev) => {
        if (prev >= targets.carsServiced) return targets.carsServiced;
        return Math.min(prev + carsIncrement, targets.carsServiced);
      });
    }, animationInterval);

    return () => clearInterval(interval);
  }, [loading, targets]);

  return (
    <section id="impact" className="py-24 bg-cream text-center">
      <div className="max-w-5xl mx-auto px-6">
        <p className="text-xs font-semibold tracking-widest uppercase text-terracotta-600 mb-3">
          Faithful Service
        </p>
        <h2 className="font-display text-4xl md:text-5xl text-ink mb-4 leading-tight">
          Our Impact Through Christ's Love
        </h2>
        <div className="w-12 h-px bg-terracotta-600 mx-auto mb-14" />
        <div className="grid md:grid-cols-3 gap-10">
          <StatCard value={widowsHelped} label="Widows Supported" />
          <StatCard value={homesRepaired} label="Homes Repaired" />
          <StatCard value={carsServiced} label="Cars Serviced" />
        </div>
      </div>
    </section>
  );
};
